module.exports = __webpack_public_path__ + "static/img/boletoflex-logo.259a3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boletoflex-logo.png
// module id = g/cX
// module chunks = 3